module.exports = __webpack_public_path__ + "static/favicon-48f2036b740b61afa8024465d63b5fd4.ico";